'use client'

export default function AgentLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>
}
